const mimeType = {
  json: 'application/json',
  markdown: 'text/markdown',
};

export default mimeType;



//////////////////
// WEBPACK FOOTER
// ./src/mimeType.js
// module id = 8
// module chunks = 0